// extracted by mini-css-extract-plugin
export default {"content":"Feed_content__CZH43","movies":"Feed_movies__qV888"};